/**
 * Turns a YouTube, Vimeo or Loom share link into its embeddable player URL.
 * Anything else returns null, so only those three players are ever framed.
 */
export function toVideoEmbedUrl(raw: string): string | null {
  let url: URL;
  try {
    url = new URL(raw.trim());
  } catch {
    return null;
  }
  if (url.protocol !== 'https:') return null;
  const host = url.hostname.replace(/^www\./, '');
  const parts = url.pathname.split('/').filter(Boolean);

  if (host === 'youtu.be' && parts[0]) return `https://www.youtube.com/embed/${parts[0]}?rel=0&modestbranding=1`;
  if (host === 'youtube.com' || host === 'm.youtube.com') {
    const id = url.searchParams.get('v') || (['embed', 'shorts', 'live'].includes(parts[0]) ? parts[1] : null);
    return id ? `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1` : null;
  }
  if (host === 'vimeo.com' && /^\d+$/.test(parts[0] ?? '')) return `https://player.vimeo.com/video/${parts[0]}`;
  if (host === 'player.vimeo.com' && parts[0] === 'video' && parts[1]) return `https://player.vimeo.com/video/${parts[1]}`;
  if (host === 'loom.com' && (parts[0] === 'share' || parts[0] === 'embed') && parts[1]) return `https://www.loom.com/embed/${parts[1]}`;
  return null;
}
